import React from 'react';

import {LinkListFooter} from '../linkListFooter/LinkListFooter';
import {useAdditionalSeedData, useCutOff} from 'pageflow-scrolled/frontend';

export function Footer() {
  const {
    appMode,
    loaderUrl
  } = useAdditionalSeedData('handelsblatt');
  const isCutOff = useCutOff();

  const globalsScript = (
    <script dangerouslySetInnerHTML={{
      __html: `
        window.PAGEFLOW_CUT_OFF = ${isCutOff ? 'true' : 'false'};
      `}} />
  );

  if (appMode) {
    return globalsScript;
  }

  return (
    <>
      {isCutOff &&
       <>
         <hmg-pageflow-paywall></hmg-pageflow-paywall>
         <script type="module" src={`${loaderUrl}?c=pageflow_paywall`}></script>
       </>}
      <script type="module" src={`${loaderUrl}?c=pageflow_piano`}></script>
      {globalsScript}
      <LinkListFooter />
    </>
  )
}
